import React, { useState, useEffect, useRef } from 'react'
import Layout from './Layout'
import './Style.css';
import { Link, Navigate } from 'react-router-dom';
import SearchHead from './SearchHead';
import { useSelector, useDispatch } from 'react-redux';
import { orderActions } from '../_actions';
import { convertNumberFrench } from '../_helpers';
import { HiOutlineDownload } from 'react-icons/hi'
import moment from 'moment';
import PageLoaderComp from '../component/pageLoaderComp';
import { PageHeader, ResponsiveDataTable } from './Components';

export default function AnnoncesPubliees() {
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.authentication.user);
    const [pageLoading, setPageLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');

    const TabHead = [
        'Nom du client',
        'Formulaire',
        'Journal de diffusion',
        'Montant',
        'Date de création',
        'Facture',
        'Attestation',
    ]

    const [tabData, setTabData] = useState([]);
    const [totalRows, setTotalRows] = useState([]);
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const userData = (currentUser) => {
        // If user.data exists, use it; otherwise, use user directly
        return currentUser && currentUser.data ? currentUser.data : currentUser;
    };
    const user = userData(currentUser);
    const getAllDevise = () => {
        setPageLoading(true)
        dispatch(orderActions.getAll(user?.id, "devis")).then((data) => {
            setPageLoading(false)
            setTabData(data);
            setTotalRows(data);
        })
            .catch(() => {
                setPageLoading(false)
            });

    }

    const getAllDeviseRef = useRef(getAllDevise);
    useEffect(() => {
        window.scrollTo(0, 0)
        getAllDeviseRef.current();
    }, []);

    if (!currentUser) {
        return <Navigate to="/" />;
    }

/* 
    const filteredRows = tabData.filter((row) => {
        return Object.values(row).some((value) =>
            value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        );
    }); */

    return (
        <>
        {pageLoading ?
        <PageLoaderComp />
        : ""}
        <Layout>
            <div className='mb-8 col-span-12 xl:col-span-9'>
                <div className='max-w-[1126px] w-full h-full bg-white rounded-[20px] overflow-hidden'>
                    <PageHeader title="Annonces publiées">
                        <SearchHead setTotalRows={setTotalRows} totalRows={totalRows} setTabData={setTabData} />
                    </PageHeader>

                    <div className='mt-4 sm:mt-6 md:mt-8 px-3 sm:px-6 md:px-9 pb-4 sm:pb-6'>
                        <ResponsiveDataTable
                            columns={[
                                {
                                    header: 'Nom du client',
                                    field: 'username',
                                    render: (item) => item.username,
                                },
                                {
                                    header: 'Formulaire',
                                    field: 'form_type',
                                    render: (item) => item.form_type,
                                    truncate: true,
                                },
                                {
                                    header: 'Journal de diffusion',
                                    field: 'journal_detail',
                                    render: (item) => item.journal_detail,
                                    truncate: true,
                                },
                                {
                                    header: 'Montant',
                                    field: 'total',
                                    render: (item) => <span className="font-semibold">{convertNumberFrench(item.total)} €</span>,
                                },
                                {
                                    header: 'Date de création',
                                    field: 'creation_date',
                                    render: (item) => moment(item.creation_date).format("DD/MM/YYYY"),
                                },
                                {
                                    header: 'Facture',
                                    isAction: true,
                                    render: (item) => (
                                        <Link 
                                            target="_blank" 
                                            to={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/invoice/${item.votre_pdf}`}
                                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors inline-flex"
                                            title="Télécharger la facture"
                                        >
                                            <HiOutlineDownload className='w-5 h-5' />
                                        </Link>
                                    ),
                                },
                                {
                                    header: 'Attestation',
                                    isAction: true,
                                    render: (item) => (
                                        <Link 
                                            target="_blank" 
                                            to={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/attestation/${item.attestation}`}
                                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors inline-flex"
                                            title="Télécharger l'attestation"
                                        >
                                            <HiOutlineDownload className='w-5 h-5' />
                                        </Link>
                                    ),
                                },
                            ]}
                            data={tabData}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            renderActions={(item) => (
                                <div className="flex items-center gap-2 justify-center">
                                    <Link 
                                        target="_blank" 
                                        to={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/invoice/${item.votre_pdf}`}
                                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors flex items-center gap-1"
                                    >
                                        <HiOutlineDownload className='w-5 h-5' />
                                        <span className="text-xs">Facture</span>
                                    </Link>
                                    <Link 
                                        target="_blank" 
                                        to={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/attestation/${item.attestation}`}
                                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors flex items-center gap-1"
                                    >
                                        <HiOutlineDownload className='w-5 h-5' />
                                        <span className="text-xs">Attestation</span>
                                    </Link>
                                </div>
                            )}
                            emptyMessage="Aucune annonce publiée"
                            keyField="id"
                        />
                    </div>
                </div>
        </div>
        </Layout >
        </>
    )
}

